<template>
  <span v-if="this.$route.params.jenis=='TMA'">
  <NotificationPetugasTMAVue/>
  </span>
  <span v-else>
  <NotificationPetugasOmbroVue/>
  </span>
</template>

<script>
import NotificationPetugasTMAVue from './NotificationPetugasTMA.vue'
import NotificationPetugasOmbroVue from './NotificationPetugasOmbro.vue'

  export default {
    name: 'Notification Petugas',
    data: () => ({
    }),
    components: {
      NotificationPetugasTMAVue,
      NotificationPetugasOmbroVue
    }
  }
</script>